import { useState } from "react";
import GoBack from "../../../components/GoBack";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styled from "styled-components";
import {
  useFetchHomeVisitScheduleLazyQuery,
  useFetchHomeVisitScheduleQuery,
} from "../../../generated/graphql";
import Empty from "../../../components/Empty";
import FullPageLoader from "../../../components/Loaders/FullPageLoader";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";

const Div = styled.div`
  .react-datepicker,
  .react-datepicker__month-container,
  .react-datepicker__header,
  .react-datepicker__month {
    width: 100%;
    color: white !important;
  }

  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    margin: 0.7rem;
  }
`;

export default function Calender() {
  const loggedInRole = useSelector(
    (state: RootState) => state.loggedInUser.role
  );

  const loggedInClinic = useSelector(
    (state: RootState) => state.loggedInUser.clinic
  );

  const [date, setDate] = useState(new Date());

  const handleDate = (date: Date) => {
    console.log(date.toISOString().split("T")[0]);
    setDate(date);
  };

  const { loading, error, data } = useFetchHomeVisitScheduleQuery({
    variables: {
      input: {
        role: loggedInRole,
        clinicId: loggedInClinic?.id ?? null,
        date: date,
        page: 1,
        size: 25,
      },
    },
  });

  return (
    <div className="px-4 mt-2 mb-12">
      <GoBack />

      <h1 className="text-2xl font-bold">My Calendar</h1>

      {/* {error ? (
        <Empty text={error.message} />
      ) : loading ? (
        <FullPageLoader />
      ) : ( */}
      <>
        <div className="mt-6 w-full overflow-auto flex justify-center">
          <DatePicker selected={date} onChange={handleDate} inline />
        </div>
        <section className="mt-6 grid grid-cols-1 gap-y-4">
          <div className="bg-[#E9FAF2] flex items-center dark:text-black justify-between p-4">
            <div>
              <p className="mb-4 font-medium text-[.75rem]">
                Graceland General Hospital
              </p>

              <p>Home visit by Mrs Cynthia Boku</p>
            </div>

            <div>10:30 am</div>
          </div>

          <div className="bg-[#E9FAF2] flex items-center dark:text-black justify-between p-4">
            <div>
              <p className="mb-4 font-medium text-[.75rem]">
                Graceland General Hospital
              </p>

              <p>Home visit by Mrs Cynthia Boku</p>
            </div>

            <div>10:30 am</div>
          </div>
        </section>
      </>
      {/* )} */}
    </div>
  );
}
